package com.downdogapp.client.controllers

import com.downdogapp.*
import com.downdogapp.client.SequenceSettings
import com.downdogapp.client.Strings
import com.downdogapp.client.ViewController
import com.downdogapp.client.api.AppType.*
import com.downdogapp.client.api.Pose
import com.downdogapp.client.controllers.start.NewPracticePage
import com.downdogapp.client.resources.Images
import com.downdogapp.client.singleton.App
import com.downdogapp.client.views.PoseListView

class PoseListViewController(val title: String, unfilteredItems: List<Pose>) :
  ViewController() {

  val items =
    unfilteredItems
      .filter { it.name != null }
      .distinctBy { it.name }

  val searchFieldPrompt
    get() = when (App.appType) {
      ORIGINAL, INTRO, PRENATAL -> Strings.SEARCH_FOR_A_POSE
      HIIT, BARRE, SEVEN, PILATES -> Strings.SEARCH_FOR_AN_EXERCISE
      MEDITATION, RUNNING, BREATHING -> ""
    }

  private var poseConfirmCount = 0

  override val view = PoseListView(this)

  override fun onBackClicked() {
    NewPracticePage.refreshPage()
    SequenceSettings.resetCacheAndMaybeFetchSequences()
    super.onBackClicked()
  }

  fun posesMatchingSearch(searchText: String?) =
    items.filter { pose ->
      searchText?.lowercase()?.let { searchText ->
        searchText.isBlank() ||
        (pose.name?.lowercase()?.contains(searchText) ?: false)
      } ?: true
    }

  fun onPoseClicked(poseLibraryUrl: String) {
    App.openUrl(poseLibraryUrl)
  }

  fun onLikePoseClicked(pose: Pose) {
    if (SequenceSettings.getPoseLiked(pose.poseId) != true) {
      view.showPoseConfirmation(Strings.POSE_LIKED_MESSAGE(pose.name!!), Images.THUMBS_UP_ICON)
      delayedHidePoseConfirmation()
      SequenceSettings.setPoseLiked(pose.poseId, true)
    } else {
      view.hidePoseConfirmation()
      SequenceSettings.setPoseLiked(pose.poseId, null)
    }
  }

  fun onDislikePoseClicked(pose: Pose) {
    if (SequenceSettings.getPoseLiked(pose.poseId) != false) {
      view.showPoseConfirmation(Strings.POSE_DISLIKED_MESSAGE(pose.name!!), Images.THUMBS_DOWN_ICON)
      delayedHidePoseConfirmation()
      SequenceSettings.setPoseLiked(pose.poseId, false)
    } else {
      view.hidePoseConfirmation()
      SequenceSettings.setPoseLiked(pose.poseId, null)
    }
  }

  // Hide the pose confirmation after a few seconds, unless we've shown a different confirmation since
  private fun delayedHidePoseConfirmation() {
    val currentCount = ++poseConfirmCount
    App.runAfter(seconds(3)) {
      if (poseConfirmCount == currentCount) {
        view.hidePoseConfirmation()
      }
    }
  }
}
